module.exports = __webpack_public_path__ + "static/media/OGG-mobile-menu.f6c1c6e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images_hd/Ogg/OGG-mobile-menu.jpg
// module id = 613
// module chunks = 0